module.exports = __webpack_public_path__ + "img/svg/minigames.cb40a2907b0868e8f630f03d3ae3c356.svg";